import { useCallback, useMemo } from 'react';
import { CUSTOMER_CURRENCY_FALLBACK, formatPriceAmount } from '../utils/money.js';
import { useCustomerLocaleTag } from './useCustomerLocaleTag.js';

export function useCustomerFormatters(): {
  localeTag: string;
  formatPrice: (amountMajor: number, currency?: string) => string;
  formatDateTime: (iso: string) => string;
} {
  const localeTag = useCustomerLocaleTag();

  const formatPrice = useCallback(
    (amountMajor: number, currency: string = CUSTOMER_CURRENCY_FALLBACK) =>
      formatPriceAmount(amountMajor, currency || CUSTOMER_CURRENCY_FALLBACK, localeTag),
    [localeTag]
  );

  const formatDateTime = useCallback(
    (iso: string): string => {
      try {
        return new Intl.DateTimeFormat(localeTag, {
          dateStyle: 'medium',
          timeStyle: 'short',
        }).format(new Date(iso));
      } catch {
        return iso;
      }
    },
    [localeTag]
  );

  return useMemo(
    () => ({ localeTag, formatPrice, formatDateTime }),
    [localeTag, formatPrice, formatDateTime]
  );
}
